import {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  DAY_DATE_FORMAT,
  DAY_DATE_FORMAT_2,
  DAY_DATE_FORMAT_3,
  DAY_DATE_FORMAT_4,
  DAY_DATE_FORMAT_5,
  DAY_DATE_FORMAT_6,
  DAY_DATE_FORMAT_7,
  DAY_DATE_FORMAT_8,
} from './constants'

export const formatDate = (date: Date, format: string) => {
  // Extract date components
  const year = String(date.getFullYear()).slice(-2)
  const day = String(date.getDate()).padStart(2, '0')
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  // Using British date format which is en-GB
  const monthInWord = monthNames[date?.getMonth()]?.toUpperCase()
  const hours = String(date?.getHours())?.padStart(2, '0')
  const minutes = String(date?.getMinutes())?.padStart(2, '0')
  const ampm = date?.getHours() >= 12 ? 'PM' : 'AM'
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'short',
  }

  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }

  switch (format) {
    case DATE_FORMAT:
      return `${day}-${monthInWord}-${year}`

    case DATE_TIME_FORMAT:
      return `${day}-${monthInWord}-${year} ${hours}:${minutes}`

    case DAY_DATE_FORMAT:
      options.weekday = 'long'
      options.day = 'numeric'
      options.month = 'short'
      options.year = undefined
      return date.toLocaleDateString('en-GB', options)

    case DAY_DATE_FORMAT_2:
      options.weekday = 'short'
      options.day = 'numeric'
      options.month = 'short'
      options.year = undefined
      return date.toLocaleDateString('en-GB', options)

    case DAY_DATE_FORMAT_3:
      options.weekday = 'short'
      options.day = 'numeric'
      options.month = 'short'
      options.year = '2-digit'
      const datePart = date.toLocaleDateString('en-GB', options)
      const timePart = date.toLocaleTimeString('en-US', timeOptions)

      return `${datePart} | ${timePart}`

    case DAY_DATE_FORMAT_4:
      options.weekday = 'short'
      options.day = 'numeric'
      options.month = 'short'
      options.year = '2-digit'
      return date?.toLocaleDateString('en-GB', options)

    case DAY_DATE_FORMAT_5:
      options.weekday = 'short'
      options.day = 'numeric'
      options.month = 'short'
      options.year = '2-digit'
      return date?.toLocaleDateString('en-GB', options)

    case DAY_DATE_FORMAT_6:
      options.weekday = 'short'
      options.day = '2-digit'
      options.month = '2-digit'
      options.year = '2-digit'
      // return date?.toLocaleDateString('en-US', options)
      return date?.toLocaleDateString('en-GB', options)

    case DAY_DATE_FORMAT_7:
      const isoDate = date?.toISOString()?.slice(0, 10)
      return isoDate

    case DAY_DATE_FORMAT_8:
      options.weekday = undefined
      options.month = 'short'
      options.year = '2-digit'
      return date
        ?.toLocaleDateString('en-GB', options)
        ?.replace(/\d{2}$/, "'$&")

    default:
      return ''
  }
}
